import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/oraya-api";
import { useRealtime } from "@/context/CommandContext";
import { Panel, LoadingState, EmptyState } from "@/command/ccUi";

export default function Audit() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(() => api.get("/cc/audit").then(({ data }) => setRows(data)).catch(() => {}).finally(() => setLoading(false)), []);
  useEffect(() => { load(); }, [load]);
  useRealtime(["activity"], load);

  return (
    <div>
      <h1 className="display text-2xl md:text-3xl font-light text-ink">Audit Log</h1>
      <p className="text-subtle mt-1 mb-6">Immutable record of every sensitive operation.</p>
      <Panel testid="audit-panel">
        {loading ? <LoadingState /> : rows.length === 0 ? <EmptyState title="No audit events yet" /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-subtle border-b border-hairline/[0.08]">
                <th className="px-3 py-3 font-medium">Time</th><th className="px-3 py-3 font-medium">User</th>
                <th className="px-3 py-3 font-medium">Action</th><th className="px-3 py-3 font-medium">Entity</th><th className="px-3 py-3 font-medium">ID</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-b border-hairline/[0.05] text-ink" data-testid="audit-row">
                    <td className="px-3 py-3 text-subtle whitespace-nowrap">{new Date(r.created_at).toLocaleString()}</td>
                    <td className="px-3 py-3">{r.user_email}</td>
                    <td className="px-3 py-3"><span className="text-xs px-2 py-0.5 rounded-full bg-hairline/10">{r.action}</span></td>
                    <td className="px-3 py-3">{r.entity}</td>
                    <td className="px-3 py-3 text-subtle text-xs">{r.entity_id}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Panel>
    </div>
  );
}
